import { WorkflowStep } from "@/types/workflow";
import { WorkflowStepItem } from "./WorkflowStepItem";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

interface LoadingStates {
  aiHelp: { [key: string]: boolean };
  documentGeneration: { [key: string]: boolean };
}

interface WorkflowStepsListProps {
  workflow: WorkflowStep[];
  caseId: string;
  updating: boolean;
  onStatusUpdate: (index: number, newStatus: WorkflowStep["status"]) => Promise<void>;
  onAIHelp: (step: WorkflowStep) => void;
  onGenerateDocument: (step: WorkflowStep) => void;
  loadingStates: LoadingStates;
}

export function WorkflowStepsList({
  workflow,
  caseId,
  updating,
  onStatusUpdate,
  onAIHelp,
  onGenerateDocument,
  loadingStates
}: WorkflowStepsListProps) {
  const isMobile = useIsMobile();

  return (
    <div className={cn(
      "w-full space-y-4 md:space-y-6",
      "min-h-full"
    )}>
      {workflow.map((step, index) => (
        <WorkflowStepItem
          key={step.title}
          step={step}
          caseId={caseId}
          updating={updating}
          onStatusUpdate={(newStatus) => onStatusUpdate(index, newStatus)}
          onAIHelp={onAIHelp}
          onGenerateDocument={onGenerateDocument}
          isLoadingAI={loadingStates.aiHelp[step.title] || false}
          isGeneratingDoc={loadingStates.documentGeneration[step.title] || false}
        />
      ))}
    </div>
  );
}